/* Roadmap hero slideshow: crossfade, auto-advance, pause, dots. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__rmSlides) return;
    root.__rmSlides = true;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rm-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rm-dot]'));
    var pauseBtn = root.querySelector('[data-rm-pause]');
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    var i = 0, timer = null, paused = reduce, hover = false;

    function load(idx) {
      var img = slides[idx] && slides[idx].querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
    function show(idx) {
      i = (idx + slides.length) % slides.length;
      load(i); load(i + 1 < slides.length ? i + 1 : 0);
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) { s.classList.remove('is-zoom'); void s.offsetWidth; s.classList.add('is-zoom'); }
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (paused || hover || document.hidden) return;
      timer = setInterval(function () { show(i + 1); }, interval);
    }
    function setPaused(p) {
      paused = p;
      root.classList.toggle('is-paused', p);
      if (pauseBtn) pauseBtn.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
      start();
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); start(); });
    });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
    root.addEventListener('focusin', function () { hover = true; stop(); });
    root.addEventListener('focusout', function () { hover = false; start(); });
    document.addEventListener('visibilitychange', start);

    show(0);
    setPaused(paused);
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rm-slides]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-rm-slides]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rm-slide]'));
    var k = slides.indexOf(e.target);
    if (k > -1) { var d = root.querySelectorAll('[data-rm-dot]')[k]; if (d) d.click(); }
  });
})();
